import { ReactNode } from 'react';
import { PaymentMethod, StoreOrderPaymentMethod } from '../../models';
import { CreditCardIcon, SmartphoneIcon, BanknoteIcon, StoreIcon, LandmarkIcon } from '../ui/Icons';
import { formatCurrency } from '../../utils/orderFormat';

const ICON_CLASS = 'w-4 h-4';

const PAYMENT_METHOD_ICON: Record<PaymentMethod, ReactNode> = {
  [PaymentMethod.CreditCard]: <CreditCardIcon className={ICON_CLASS} />,
  [PaymentMethod.DebitCard]: <CreditCardIcon className={ICON_CLASS} />,
  [PaymentMethod.Pix]: <SmartphoneIcon className={ICON_CLASS} />,
  [PaymentMethod.Cash]: <BanknoteIcon className={ICON_CLASS} />,
  [PaymentMethod.CreditStore]: <StoreIcon className={ICON_CLASS} />,
  [PaymentMethod.BankTransfer]: <LandmarkIcon className={ICON_CLASS} />,
  [PaymentMethod.Promissory]: <LandmarkIcon className={ICON_CLASS} />,
};

interface OrderPaymentListProps {
  payments: StoreOrderPaymentMethod[];
  onRemove?: (index: number) => void;
}

export function OrderPaymentList({ payments, onRemove }: OrderPaymentListProps) {
  if (payments.length === 0) {
    return <p className="text-sm text-text-medium">Nenhuma forma de pagamento registrada.</p>;
  }

  return (
    <ul className="space-y-2">
      {payments.map((pm, idx) => (
        <li key={`${pm.id}-${idx}`} className="flex items-center justify-between gap-3 bg-champagne-light rounded-xl px-3 py-2.5">
          <span className="flex items-center gap-2 text-sm text-text-dark">
            <span className="text-text-medium" aria-hidden="true">
              {PAYMENT_METHOD_ICON[pm.paymentMethod as PaymentMethod] ?? <CreditCardIcon className={ICON_CLASS} />}
            </span>
            {pm.paymentMethodLabel}
          </span>
          <span className="flex items-center gap-1">
            <span className="text-sm font-semibold text-text-dark tabular-nums">{formatCurrency(pm.amountPaid)}</span>
            {onRemove && (
              <button
                type="button"
                onClick={() => onRemove(idx)}
                aria-label={`Remover pagamento ${pm.paymentMethodLabel}`}
                className="w-9 h-9 rounded-full flex items-center justify-center text-danger hover:bg-danger/10 transition-colors"
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            )}
          </span>
        </li>
      ))}
    </ul>
  );
}
